// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const isVitestRuntime = typeof process !== 'undefined' && process.env.VITEST === 'true';

let SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
let SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL) {
  if (isVitestRuntime) {
    SUPABASE_URL = 'https://test.supabase.co';
  } else {
    throw new Error('Missing VITE_SUPABASE_URL environment variable');
  }
}

if (!SUPABASE_PUBLISHABLE_KEY) {
  if (isVitestRuntime) {
    SUPABASE_PUBLISHABLE_KEY = 'test-anon-key';
  } else {
    throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable');
  }
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});